<template>
  <div>
    <ul class="img_arr">
      <li v-for="(item, index) in evalImg" :key="index">
        <img :src="item" @click="onEvalImg(item,index)" />
      </li>
    </ul>
    <div class="img_box" v-if="evalImgShow">
      <i class="el-icon-close" @click="onEvalClose"></i>
      <img :src="imgs" />
      <i class="el-icon-arrow el-icon-arrow-left" @click="onEvalLeft(idx-1)"></i>
      <i class="el-icon-arrow el-icon-arrow-right" @click="onEvalRight(idx+1)"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "imgEffect",
  props: {
    evalImg: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      imgs: null,
      idx: 0,
      evalImgShow: false
    };
  },
  created() {},
  methods: {
    onEvalImg(url, index) {
      console.log(url, index);
      this.imgs = url;
      this.idx = index;
      this.evalImgShow = true;
    },
    onEvalClose() {
      this.imgs = null;
      this.evalImgShow = false;
    },
    onEvalLeft(index) {
      if (index > -1) {
        this.idx = index;
        this.imgs = this.evalImg[index];
      } else {
        this.$message({
          message: "警告哦，这是第一张了",
          type: "warning"
        });
      }
    },
    onEvalRight(index) {
      if (this.evalImg.length > index) {
        this.idx = index;
        this.imgs = this.evalImg[index];
      } else {
        this.$message({
          message: "警告哦，这是最后一张了",
          type: "warning"
        });
      }
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.img_arr {
  float: left;
  width: 100%;
  font-size: 0;
  padding: 5px 0 14px;
  position: relative;
  li {
    float: left;
    width: 220px;
    height: 220px;
    font-size: 0;
    line-height: 0;
    margin-right: 33px;
    img {
      width: 220px;
      height: 220px;
    }
  }
}
.img_box {
  width: 500px;
  height: 500px;
  font-size: 0;
  line-height: 0;
  margin-bottom: 14px;
  overflow: hidden;
  position: relative;
  background: #fff;
  .el-icon-close {
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
  }
  .el-icon-arrow {
    width: 36px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.5);
    position: absolute;
    top: 50%;
    margin-top: -36px;
    &.el-icon-arrow-left {
      left: 10px;
    }
    &.el-icon-arrow-right {
      right: 10px;
    }
  }
  img {
    width: 500px;
    height: 500px;
  }
}
</style>